<template>
    <div class="">
        <div class="container">
            <CommonBreadcrumb class="my-3" />
            <!-- <Breadcrumb class="my-3" /> -->
        </div>
        <section class="banner_block">
            <div class="banner_upper">
                <h1 class="mb-0 font-active">Lab Diamonds </h1>
                <!-- <p class="mb-0" v-if="$country.is_india">Experience The Future Of Gemstones</p> -->
                <!-- <p class="mb-0" v-else>Continue your legacy with pride.</p> -->
                <p class="mb-0">The Next Gen Luxury</p>
                <NuxtLink class="anker" :to="localePath({ name:'loose-listing'})">Shop Now</NuxtLink>
            </div>
            <picture>
                <source media="(min-width: 768px)" width="1903" height="656" type="image/webp" srcset="~/assets/landing/loose/banner.webp">
                <source media="(min-width: 768px)" width="1903" height="656" type="image/jpeg" srcset="~/assets/landing/loose/banner.jpg">

                <source media="(max-width: 767px)" width="944" height="500" type="image/webp" srcset="~/assets/landing/loose/banner_mobile.webp">
                <source media="(max-width: 767px)" width="944" height="500" type="image/jpeg" srcset="~/assets/landing/loose/banner_mobile.jpg">
                <!-- <source media="(max-width: 767px)" width="944" height="500"  srcset="/landing/loose/banner_mobile.webp"> -->
                <img alt="Continue your legacy with pride" width="1903" height="656" type="image/jpeg" src="~/assets/landing/loose/banner.jpg">
            </picture>
        </section>
        <div class="container container_fluid">
            <div class="extra_text">
                <p class="mb-0" v-if="$country.is_india">Lab grown diamonds are budget-friendly, sustainable diamonds with brilliant sparkle and shine. Our lab created diamonds for {{ $t('jewelry') }} are created in state-of-the-art laboratories using renewable energy, making your pick an environmentally conscious choice. When you choose lab created diamonds from us to celebrate your special moment, you also help safeguard the planet with your decision.</p>
                <p class="mb-0" v-else>Lab grown diamonds are budget-friendly, sustainable diamonds with a brilliant sparkle and shine. Our lab created diamonds for {{ $t('jewelry') }} are created in state-of-the-art laboratories using renewable energy, making your pick an environmentally conscious choice. When you choose lab created diamonds from us to celebrate your special moment, you also help in safeguarding the planet by your decision.</p>
            </div>
        </div>

        <section class="shape_block for_desktop">
            <div class="container">
                <LandingShopByShape />
            </div>
        </section>
        <section class="for_mobile">
            <CommonShapeSlider  />
        </section>
        <div class="container-fluid container_fluid">
            <LandingCyorBanner :page="'loose'"/>
        </div>
        <div class="container what_lab">
            <div class="row align-items-center">
                <div class="col-md-6 col-12">
                    <picture>
                    <source width="577" height="465" type="image/webp" srcset="~/assets/home/about/about.webp">
                    <img alt="What is a lab diamond ?" loading="lazy" width="577" height="465" type="image/jpeg" src="~/assets/home/about/about.jpg">
                    </picture>
                </div>
                <div class="col-md-6 col-12">
                    <div class="what_lab_text">
                      
                        <h2 class="mb-3 font-active">What is a lab diamond ? </h2>
                        <p class="mb-0" v-if="$country.is_india">
                            Shopping for a lab grown diamond is a wise, ethical, and ecological decision, as you play your part in saving the planet while also obtaining a 100% conflict-free gemstone. Sustainable, eco-friendly, and well within budget—these features make lab diamonds the future of the diamond industry!
                        </p>
                        <p class="mb-0" v-else>    
                            Lab grown diamonds are grown in state-of-the-art laboratories using advanced technology that emulates natural diamond-growing procedures. Lab diamonds and mined diamonds are optically the same as they have the same chemical structure and composition. Even a trained eye would need help to differentiate between the two.
                            <br><br>
                            Shopping for a lab grown diamond is a wise, ethical, and ecological decision as you play your part in saving the planet while also obtaining a 100% conflict-free gemstone. Sustainable, eco-friendly, and well within budgets; these features make lab diamonds the future of the diamond industry!
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <section class="compare_block">
            <div class="container">
                <LandingDiamondCompare />
            </div>
        </section>
        
        <div class="container mb-md-5 py-4" id="Diamond_Certification">
            <div class="row align-items-center" >
                <div class="col-md-6 col-12 what_lab_text">
                    <picture>
                    <source width="580" height="350" type="image/webp" srcset="~/assets/landing/loose/certificate.webp">
                    <img alt="Diamond Certification" loading="lazy" width="580" height="350" type="image/jpeg" src="~/assets/landing/loose/certificate.jpg">
                    </picture>
                </div>
                <div class="col-md-6 col-12 mob_padd_none">
                    <div class="what_lab_text">
                        <h2 class="mb-4 font-active">Diamond Certification</h2>
                        <p class="mb-4" v-if="$country.is_india">
                            Lab grown diamonds undergo a grading and certification system just like mined stones. These are graded by independent diamond certification labs based on their cut, clarity, colour, and carat (the 4C’s). Friendly Diamonds’ lab created diamonds are certified by the <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'gia-certified' } })">Gemological Institute of America (GIA)</NuxtLink> and <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'igi-certified' } })">International Gemological Institute (IGI)</NuxtLink>.
                        </p>
                        <p class="mb-4" v-else>
                            Lab grown diamonds undergo a grading and certification system just like mined stones.
                           
                            These are graded by independent diamond certification labs based on their cut, clarity, color, and carat (the 4C’s).
                           
                            The Friendly Diamonds’ lab created diamonds are certified by the <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'gia-certified' } })">Gemological Institute of America (GIA)</NuxtLink> and <NuxtLink :to="localePath({ name:'loose-listing', params:{ start_with: 'igi-certified' } })">International Gemological Institute (IGI)</NuxtLink>. 
                        </p>
                        <NuxtLink class="anker mb-3" :to="localePath({ name:'loose-listing', params:{ start_with: 'gia-certified' } })">Shop GIA certified diamonds</NuxtLink><br>
                        <NuxtLink class="anker" :to="localePath({ name:'loose-listing', params:{ start_with: 'igi-certified' } })">Shop IGI certified diamonds</NuxtLink>
                    </div>
                </div>
               
            </div>
        </div>
        
        <!-- <BlockchainEnabled /> -->
        <div class="container popular_block">
            <LandingPopularCategory />
        </div>
        <div class="container creation_block">
            <div class="row align-items-center">
                <div class="col-md-6 col-12">
                    <picture>
                    <source width="725" height="590" type="image/webp" srcset="~/assets/landing/loose/diamond_made.webp">
                    <img class="radious_eight" alt="How are lab diamonds made" loading="lazy" width="725" height="590" type="image/jpeg" src="~/assets/landing/loose/diamond_made.jpg">
                    </picture>
                </div>
                <div class="col-md-6 col-12 creation_text">
                    <h3 class="mb-4 font-active">How are lab diamonds made ? </h3>
                    <p>
                        To know how lab diamonds are created or how lab diamonds are grown, you must first understand how mined diamonds are formed. When exposed to heat and pressure, carbon dioxide forms into diamonds inside the earth's core and is transported to the earth's top layers through volcanic eruptions. <br><br> 
                        Lab grown diamonds are created by emulating these natural conditions of the earth through advanced technological processes like HPHT and CVD. 
                    </p>
                    <LandingDiamondMadeFAQ />
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row align-items-center row_mod">
                <div class="col-md-6 col-12 mob_padd_none">
                    <div class="what_lab_text">
                        <h2 class="mb-4 font-active"> 4 C’s Of A Lab Grown Diamond </h2>
                        <p class="mb-4" v-if="$country.is_india">
                            At Friendly Diamonds, we believe that knowing your diamond is essential before making a purchase. The <NuxtLink :to="localePath('/4-cs-diamond')">The 4C’s</NuxtLink> help you understand the main characteristics of your diamond (Cut, Colour, Clarity, Carat) and are used by grading institutions for assessing its quality.
                        </p>
                        <p class="mb-4" v-else>
                            At Friendly Diamonds, we believe that knowing your diamond is essential before making its purchase. <NuxtLink :to="localePath('/4-cs-diamond')">The 4C’s</NuxtLink> help you understand the main characteristics of your diamond (Cut, Color, Clarity, Carat) and are used by grading institutions for assessing its quality.
                        </p>
                        <NuxtLink class="anker" :to="localePath('/4-cs-diamond')">learn about the 4 C’s</NuxtLink>
                    </div>
                </div>
                <div class="col-md-6 col-12 what_lab_text">
                    <picture>
                    <source width="596" height="596" type="image/webp" srcset="~/assets/landing/loose/four_cs.webp">
                    <img alt="4 C’s Of A Lab Grown Diamond" loading="lazy" width="596" height="596" type="image/jpeg" src="~/assets/landing/loose/four_cs.jpg">
                    </picture>
                </div>
            </div>
        </div>
        <!-- <section class="shape_block">
            <div class="container">
            </div>
        </section> -->
        <HomeBlog :type="'loose'" />
        <div class="container what_lab">
            <FaqDynamicFaq />
        </div>
        <div class="container" v-if="$country.trustpilot">
            <HomeTrustpilotReview />
        </div>
    </div>
</template>

<script setup>

    const localePath = useLocalePath();
    const { $country } = useNuxtApp();
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );


    definePageMeta({
        keepalive: true
    })

</script>

<style scoped>
.shape_block{
    background: #faf9f7;
    padding: 3% 0;
}
.row{
     margin-left: 0;
     margin-right: 0;
}
.container_fluid{
    padding: 2% 3%;
}
section.banner_block{
    position: relative;
}
.banner_upper {
    position: absolute;
    top: 50%;
    left: 33%;
    transform: translate(-50%, -50%);
}
.banner_upper h1 {
    font-size: 48px;
    color: #000;
}
.banner_upper span {
    font-size: 15px;
    display: block;
    font-weight: 600;
}
.banner_upper_mod h4{
    font-size: 40px;
    color: #fff;
}
.banner_upper_mod p {
    color: #fff !important;
    font-size: 16px;
    padding: 4% 0;
}
.banner_upper p {
    color: #6a6161;
    font-size: 16px;
    padding: 3% 0 5%;
    color: #000;
}
 a.anker {
    display: inline-block;
    font-size: 13px;
    color: #000;
    text-transform: uppercase;
    font-weight: 600;
    border: 1px solid #000;
    padding: 12px 25px;
    border-radius: 4px;
}
a.anker_light{
    color: #fff;
    border: 1px solid #fff;
}
/* ------------------ */
.extra_text{
    padding: 4% 0;
}
.extra_text p{
    color: #6a6161;
    font-size: 16px;
    text-align: center;
}
.what_lab {
    padding: 4% 0;
}

.what_lab_text h2 {
    font-size: 32px;
}
.what_lab_text p {
    font-size: 16px;
    color: #6a6161;
}
.what_lab_text p a {
    font-size: 14px;
    color: var(--green);
    text-decoration: underline;
}
/* --------------- */
.compare_block{
    background: #f8f8f8;
    padding: 3% 0;
}
/* --------------- */
.popular_block {
    padding: 0 0 4% 0;
}
/* --------------- */
.creation_block {
    padding: 0 0 4% 0;
}
.creation_block h3 {
    font-size: 32px;
}
.creation_block p {
    font-size: 16px;
    color: #6a6161;
}
.creation_text{
    padding: 0 5%;
}
.creation_block p a{
    font-size: 14px;
    color: var(--green);
    text-decoration: underline;
}
/* --------------- */
@media(max-width: 1300px){
    .banner_upper h1{
        font-size: 32px;
    }
}
@media(max-width: 992px){
   
    .shape_block{
        padding: 3%;
    }
    .extra_text p{
        font-size: 16px;
    }
    .extra_text p br{
        display: none;
    }
   
    .banner_upper h1{
        font-size: 26px;
    }
    .banner_upper h1 br{
        display: none;
    }
    .banner_upper p{
        font-size: 16px;
        padding-top: 2%;
    }
    a.anker {
        padding: 7px 14px;
    }
    .what_lab_text h2 {
        font-size: 24px;
    }
    .what_lab_text {
        padding:  0;
    }
    .creation_text {
        padding: 0;
    }
    .creation_block h3 {
        font-size: 24px;
    }


}
@media(max-width: 767px){
    .what_lab {
        padding: 4%;
    }
    .banner_upper {
        position: relative;
        top: 0;
        left: 0;
        transform: none;
        width: 100%;
        text-align: center;
        background: #f2efe7;
        padding: 6% 6% 8% 6%;
        margin-bottom: -5px;
    }
    .shape_block {
        padding: 5%;
    }
    .extra_text p{
        font-size: 16px;
    }
    .extra_text {
        padding: 10% 5%;
    }
  
    .banner_upper h1{
        font-size: 32px;
    }
    .banner_upper p,.banner_upper span {
        font-size: 16px;
    }
    .row_mod{
        flex-direction: column-reverse;
    }
    a.anker{
        padding: 10px 20px;
    }
    .what_lab_text {
        padding: 5% 0;
    }
    .banner_upper.banner_upper_mod {
        position: relative;
        top: 0;
        left: 0;
        transform: unset;
        color: #000;
        width: 100%;
        margin: 0 auto;
        padding: 10% 6%;
        background: #ddc5bb;
    }

    .banner_upper.banner_upper_mod h1, .banner_upper.banner_upper_mod p {
        text-align: left;
    }
    .banner_upper.banner_upper_mod {
        width: 40%;
    }
    .banner_upper.banner_upper_mod h1 {
        font-size: 24px;
    }

    .banner_upper.banner_upper_mod a.anker {
        display: block;
    }
    .creation_text{
        padding: 8% 5% 0 5%;
    }
    .mob_padd_none {
        padding: 0;
    }
}
/* ---------------- */
.banner_upper {
    position: absolute;
    top: 50%;
    left: 25%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: max-content;
}
.banner_upper h1 {
    font-size: 70px;
    color: #606060;
    text-transform: uppercase;
}
.banner_upper p {
    color: #000;
    font-size: 18px;
    padding: 2% 0 4% 0;
    text-transform: capitalize;
}
.banner_upper a {
    min-width: 270px;
    letter-spacing: 1px;
}
@media(max-width: 1300px){
    .banner_upper h1{
        font-size: 48px;
    }
    .banner_upper p{
        font-size: 16px;
    }
    .banner_upper a {
        min-width: 220px;
        padding: 9px;
    }
}
@media(max-width: 992px){
  
    .banner_upper h1{
        font-size: 26px;
    }
    .banner_upper h1 br{
        display: none;
    }
    .banner_upper p{
        font-size: 16px;
        padding: 4% 2% 8% 0;    
    }
}
@media(max-width: 767px){
    .banner_upper {
        width: 100%;
        top: 73%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .banner_upper h1{
        font-size: 30px;
    }
    .banner_upper p {
        font-size: 16px;
        padding: 4% 2% 6% 0;
    }
}
</style>
